import { apiFetch } from "../api.js";
import type {
  IntradayResponse,
  NewsResponse,
  PricesRangeResponse,
} from "./types.js";

/**
 * Market-data API module — wraps the tenant-shared (no household-access
 * check) endpoints landed in Phase 2 Sessions 2.2a + 2.2b.
 *
 * All three endpoints take a JWT and return JSON envelopes unwrapped by
 * `apiFetch` to the listed types.
 */

export function getPricesRange(
  ticker: string,
  startDate: string,
  endDate: string,
  indicators: readonly string[] = [],
): Promise<PricesRangeResponse> {
  const qs = new URLSearchParams({ startDate, endDate });
  if (indicators.length > 0) {
    // Sort + join → stable cache key for any TanStack Query caller
    // building the key from the same inputs.
    qs.set("indicators", [...indicators].sort().join(","));
  }
  return apiFetch<PricesRangeResponse>(
    `/v1/prices/${encodeURIComponent(ticker)}?${qs.toString()}`,
  );
}

export interface NewsQuery {
  limit?: number;
  before?: string;
}

export function getNews(
  ticker: string,
  query: NewsQuery = {},
): Promise<NewsResponse> {
  const qs = new URLSearchParams({ ticker });
  if (query.limit !== undefined) qs.set("limit", String(query.limit));
  if (query.before !== undefined) qs.set("before", query.before);
  return apiFetch<NewsResponse>(`/v1/news?${qs.toString()}`);
}

export function getIntradayBars(
  ticker: string,
  timeframe: "5min" | "1hour",
  date: string,
): Promise<IntradayResponse> {
  const qs = new URLSearchParams({ timeframe, date });
  return apiFetch<IntradayResponse>(
    `/v1/intraday/${encodeURIComponent(ticker)}?${qs.toString()}`,
  );
}
